export default "__VITE_ASSET__DsmlVFa7__"